module.exports = __webpack_public_path__ + "static/site-1783527333127/img/logo_amex.2dc1fd72.svg";